// extracted by mini-css-extract-plugin
export default {"SaveResetButtons":"styles_SaveResetButtons__UevJ9","resetButton":"styles_resetButton__-Q9Zo"};